import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import DialogConfirm from '../molecules/DialogConfirm';
import TransitionButton from '../molecules/TransitionButton';
import Popup from '../molecules/Popup';

interface Props {
  reception_cd: string;
  movePrevStep: VoidFunction;
  moveNextStep: VoidFunction;
  reception_id: number;
  declineExecution: () => void | boolean;
  contractExecution: () => void | boolean;
  status_code: number;
}

// KWANKGM04080_契約申込確認
const FooterContractApplicationConfirmation: React.FC<Props> = ({
  reception_cd,
  reception_id,
  movePrevStep,
  moveNextStep,
  declineExecution,
  contractExecution,
  status_code,
}) => {
  const history = useHistory();
  const [modal_decline_open, setModalDeclineOpen] = useState(false);

  // 「辞退する」をクリックした時のアクション
  const handleClickOpenDecline = () => {
    setModalDeclineOpen(true);
  };

  // ダイアログ内の辞退するボタンをクリックした時のアクション
  const handleClickDecline = async () => {
    const result = await declineExecution();
    if (result) {
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/declined`);
    }
  };

  // 「上記の内容で実行する」をクリックした時のアクション
  const handleClickNext = async () => {
    const result = await contractExecution();
    if (result) {
      moveNextStep();
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/finish`);
    }
  };

  // 「戻る」ボタンをクリックした時のアクション
  const handleClickBack = () => {
    movePrevStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
  };

  return (
    <>
      <Row className="my-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-danger">
          <div className="text-left sp-button-center">
            <a className="btn btn-xl btn-danger sp-btn-height" onClick={handleClickOpenDecline}>
              辞退する
            </a>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
          <div className="text-right sp-button-center">
            <a
              className="btn btn-xl btn-main-color sp-btn-height ml-auto"
              onClick={handleClickNext}
            >
              上記の内容で実行する
            </a>
          </div>
        </Col>
      </Row>
      <TransitionButton label="戻る" handleClick={handleClickBack} />
      <Popup
        title="契約申込の辞退確認"
        text="契約申込の辞退となります。よろしいですか？"
        first_button={{
          label: '辞退する',
          variant: 'danger',
          handleClick: () => {
            handleClickDecline();
            setModalDeclineOpen(false);
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => setModalDeclineOpen(false),
        }}
        toggleClose={() => setModalDeclineOpen(false)}
        toggleShow={modal_decline_open}
      />
    </>
  );
};

export default memo(FooterContractApplicationConfirmation);
